import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel"
}
const _hoisted_2 = { class: "card gy-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, "Errors", -1)
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.errors.length)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (value, idx) => {
              return (_openBlock(), _createBlock("p", {
                class: "card-text",
                key: idx
              }, _toDisplayString(value), 1))
            }), 128))
          ])
        ]),
        _hoisted_5
      ]))
    : _createCommentVNode("", true)
}